import ReactDOM from 'react-dom/client'
import App from './App'
import { initAnalytics } from './lib/monitoring/analytics'

/**
 * P5-04 / P8-04: 初始化性能监控、错误上报、业务埋点
 */
initAnalytics();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <App />,
)
